module.exports = __webpack_public_path__ + "static/media/sell_take_order_rent_7.a0bf58ee.jpg";